import { render, staticRenderFns } from "./distributionUser.vue?vue&type=template&id=ad1afe50&scoped=true&"
import script from "./distributionUser.vue?vue&type=script&lang=js&"
export * from "./distributionUser.vue?vue&type=script&lang=js&"
import style0 from "./distributionUser.vue?vue&type=style&index=0&id=ad1afe50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1afe50",
  null
  
)

export default component.exports